import React from "react";
import { formatPrice } from "../../utils/formatPrice";

function OrderTotals({
  deliveryFee,
  totalDiscount,
  totalPrice,
  deliveryFreeThreshold,
  showDeliveryFee = true,
  showPartnerDiscount = true,
}) {
  return (
    <>
      {showDeliveryFee && (
        <div className="flex justify-between text-md md:text-lg font-light mt-2">
          <div>
            <p>
              Delivery{" "}
              {deliveryFreeThreshold > 0 && (
                <span className="text-sm text-gray-500">
                  (free from {formatPrice(deliveryFreeThreshold)} €)
                </span>
              )}
            </p>
          </div>
          <p>{formatPrice(deliveryFee)} €</p>
        </div>
      )}

      {showPartnerDiscount && totalDiscount > 0 && (
        <div className="flex justify-between text-md md:text-lg font-light mt-2">
          <p>Partner Discount</p>
          <p>-{formatPrice(totalDiscount)} €</p>
        </div>
      )}

      <hr className="my-4 border-gray-300" />

      <div className="flex justify-between font-semibold text-md md:text-lg">
        <p>Total</p>
        <p>{formatPrice(totalPrice)} €</p>
      </div>
    </>
  );
}

export default OrderTotals;
